// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"x3-z","displaySixCardTiles":"y3-z"};